import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  card: {
    padding: 15,
    marginBottom: 20,
    width: "100%",
  },
  statusDot: {
    border: `1px solid #9A9A9A`,
    borderRadius: "50%",
    width: "25px",
    height: "25px",
  },
  rowWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  greenText: {
    color: theme.palette.success.main,
  },
  grayFont: {
    color: "#9A9A9A",
    fontSize: "14px",
    textAlign: "left",
  },
  icon: {
    color: "#fff",
    width: "90%",
  },
  acceptedDot: {
    backgroundColor: theme.palette.success.main,
    border: `1px solid ${theme.palette.success.main}`,
  },
  rejectedDot: {
    backgroundColor: theme.palette.error.main,
    border: `1px solid ${theme.palette.error.main}`,
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "80%",
  },
  button: {
    margin: "10px 0",
  },
}))

export default useStyles
